import React from "react";
import { Routes, Route } from "react-router-dom";
import InformePublico from "views/informe/InformePublico";

export default function InformeLayout() {
  return (
    <Routes>
      <Route path="/:token" element={<InformePublico />} />
    </Routes>
  );
}
